import React, { useState } from 'react'
import { useDebounceEffect } from 'ahooks'
import { Configs } from '../types'

const Config = ({ onChangeLayoutConfig, config }: Configs) => {
    const [integration, setIntegration] = useState(config.integration)

    useDebounceEffect(
        () => {
            onChangeLayoutConfig('integration', integration)
        },
        [integration],
        { wait: 500 }
    )
    return (
        <div>
            <label>Integration</label>
            <input type="text" value={integration} onChange={e => setIntegration(e.target.value)} />
            <label className="smart-mobility-positions-report-hide-fields">Hide fields</label>

            <div className="smart-mobility-positions-report-hide-fields-checkboxes">
                <span className="checks">
                    <input
                        type="checkbox"
                        id="timestamp"
                        checked={config.hideTimestamp}
                        onChange={() => onChangeLayoutConfig('hideTimestamp', !config.hideTimestamp)}
                    />
                    <label htmlFor="timestamp">timestamp</label>
                </span>
                <span className="checks">
                    <input
                        type="checkbox"
                        checked={config.hideLatlng}
                        onChange={() => onChangeLayoutConfig('hideLatlng', !config.hideLatlng)}
                    />
                    <label>__lat/__lng</label>
                </span>
            </div>
        </div>
    )
}

export default Config
